import './faqs.scss';
import 'bootstrap/js/dist/collapse';
import { sanitizeString } from '../../../assets/js/text-renderer';

const getFaqs = (liData) => `
<div id="accordionGroup">
  ${liData.map((li, index) => `
    <article
      class="faq-card ${index !== 0 ? "collapsed" : ""}"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#collapse${index + 1}"
      aria-expanded="${index === 0}"
      aria-controls="collapse${index + 1}"
    >
      <header id="heading${index + 1}">
        <h5 class="me-3 mb-0">${li.title}</h5>
        <i class="icon-fa-chevron-down icon-lg"></i>
      </header>
      <section
        id="collapse${index + 1}"
        class="accordion-collapse collapse ${index === 0 ? "show" : ""}"
        aria-labelledby="heading${index + 1}"
        data-bs-parent="#accordionGroup"
      >
        <div class="pt-2">${li.content}</div>
      </section>
    </article>`
    )
    .join("")}
</div>`

/**
 * Custom FAQs Web Component
 * 
 * This component renders a list of FAQs in an accordion format.
 * 
 * Attributes:
 * - <li> - title: Sets the title of the FAQ.
 * - <li> - content: Sets the content of the FAQ.
 * 
 * Usage:
 * The component should contain <li> elements as children, each with 'title' and 'content' attributes.
 * 
 * Example:
 * <custom-faqs>
 *   <li title="FAQ 1" content="Content for FAQ 1"></li>
 *   <li title="FAQ 2" content="Content for FAQ 2"></li>
 * </custom-faqs>
 */
class Faqs extends HTMLElement {
  connectedCallback() {
    if (
      DEVELOPMENT || (
      window['__PRERENDER_INJECTED'] && 
      window['__PRERENDER_INJECTED'].render_text)
    ) this.render();
  }

  render() {
    const orderLists = Array.from(this.querySelectorAll(':scope > li'));
    const liData = this.getFaqData(orderLists); 
    this.innerHTML = getFaqs(liData);
  }

  getFaqData(orderLists) {
    return orderLists.map((li) => ({
      title: sanitizeString(li.getAttribute("title")),
      content: sanitizeString(li.getAttribute("content")),
    }));
  }
}

customElements.define('custom-faqs', Faqs);